import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { useState } from "react";
import { useEffect } from "react";
import { getData, postData } from "../Utils";
import { useGlobalState } from "../global";

export default function Settings() {
  const [state, dispatch] = useGlobalState();
  const [payment_key, setPayment_key] = useState("");
  const [booking_key, setBooking_key] = useState("");
  const [booking_amount, setBooking_amount] = useState("");
  const [region, setRegion] = useState("");
  const [currency, setCurrency] = useState("");
  const [support_email, setSupportEmail] = useState("");
  const [support_phone, setSupport_phone] = useState("");
  const [legal_name, setLegal_name] = useState("");
  const [legal_address, setLegal_address] = useState("");
  const [vat, setVat] = useState("");
  const [vat_nr, setVatNr] = useState("");
  const [bank, setBank] = useState("");
  const [eban, setEban] = useState("");
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    getData("self").then((me) => {
      setPayment_key(me.payment_key);
      setBooking_amount(me.booking_amount);
      setBooking_key(me.booking_key);
      setRegion(me.region);
      setCurrency(me.currency);
      setSupportEmail(me.support_email);
      setSupport_phone(me.support_phone);
      setLegal_name(me.legal_name);
      setLegal_address(me.legal_address);
      setVat(me.vat);
      setVatNr(me.vat_nr);
      setBank(me.bank);
      setEban(me.eban);
      setLogo(me.logo);
    });
  }, []);
  function onChangeKey(e) {
    setPayment_key(e.target.value);
  }
  function handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setLogo(reader.result);
    };
    reader.readAsDataURL(file);
  }

  function save() {
    postData("self", { payment_key, booking_key, booking_amount, region, currency, support_email, support_phone, legal_name, legal_address, vat, logo, vat_nr, eban, bank })
      .then((r) => {
        dispatch({ message: "Save successful" });
      })
      .catch((error) => {
        dispatch({ error: `Error. not saved ${error}` });
      });
  }

  return (
    <Form>
      <FormGroup>
        <Label>Payment key</Label>
        <Input type="text" name="payment_key" value={payment_key} onChange={onChangeKey} />
      </FormGroup>
      <FormGroup>
        <Label>Booking key</Label>
        <Input type="text" name="booking_key" value={booking_key} onChange={(e) => setBooking_key(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Booking amount</Label>
        <Input type="text" name="booking_amount" value={booking_amount} onChange={(e) => setBooking_amount(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Region</Label>
        <Input type="text" name="region" value={region} onChange={(e) => setRegion(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Currency</Label>
        <Input type="text" name="currency" value={currency} onChange={(e) => setCurrency(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Support email</Label>
        <Input type="text" name="currency" value={support_email} onChange={(e) => setSupportEmail(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Support phone</Label>
        <Input type="text" name="currency" value={support_phone} onChange={(e) => setSupport_phone(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Legal name</Label>
        <Input type="text" name="currency" value={legal_name} onChange={(e) => setLegal_name(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Legal address</Label>
        <Input type="text" name="currency" value={legal_address} onChange={(e) => setLegal_address(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>VAT rate in % (0 ... 100)</Label>
        <Input type="text" name="currency" value={vat} onChange={(e) => setVat(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>VAT number</Label>
        <Input type="text" name="currency" value={vat_nr} onChange={(e) => setVatNr(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Bank</Label>
        <Input type="text" name="currency" value={bank} onChange={(e) => setBank(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>EBAN</Label>
        <Input type="text" name="currency" value={eban} onChange={(e) => setEban(e.target.value)} />
      </FormGroup>
      Logo:
      <div className="logo-image-preview">{logo && <img alt="preview" className="logo-image-preview" src={logo} />}</div>
      <input type="file" onChange={(e) => handleImageChange(e)} />
      <Button color="primary" onClick={save}>
        Save
      </Button>
    </Form>
  );
}

class Settings_c extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onChangeValue = this.onChangeValue.bind(this);
  }
  onChangeValue(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  componentDidMount() {
    const payment_key = "123-AVD-KKK-nfdsafsd-333";
    this.setState({ payment_key });
  }
  render() {
    const payment_key = this.state.payment_key || "";
    return (
      <Form>
        <FormGroup>
          <Label>Payment key</Label>
          <Input type="text" name="payment_key" value={payment_key} onChange={this.onChangeValue} />
        </FormGroup>
        <Button color="primary">Save</Button>
      </Form>
    );
  }
}
